export default "__VITE_ASSET__75ae883a__"